import { aggregateFieldsIcon, chartColumnClusteredIcon, checkIcon, deliciousIcon, envelopIcon, exclamationCircleIcon, exeIcon, fileConfigIcon, fileCsvIcon, fileErrorIcon, fileExcelIcon, fileIcon, fileImageIcon, fileMdbIcon, filePdfIcon, filePresentationIcon, fileProgrammingIcon, fileTxtIcon, fileVideoIcon, fileWordIcon, fileZipIcon, fontFamilyIcon, gearsIcon, hyperlinkOpenIcon, linkIcon, redoIcon, ungroupIcon,filePptIcon } from '@progress/kendo-svg-icons';
import { Icons } from './mcd-icons';

export class iconHelper {
public static svgIcons = [
    { ext: '.PDF', icon: filePdfIcon, color: '#', style: { 'color': 'red' } },

    //office
    { ext: '.DOC', icon: fileWordIcon, color: '#', style: { 'color': '#227AEE' } },
    { ext: '.DOCX', icon: fileWordIcon, color: '#', style: { 'color': '#227AEE' } },
    { ext: '.DOCM', icon: fileWordIcon, color: '#', style: { 'color': '#227AEE' } },
    { ext: '.XLS', icon: fileExcelIcon, color: '#', style: { 'color': '#37b400' } },
    { ext: '.XLSX', icon: fileExcelIcon, color: '#', style: { 'color': '#37b400' } },
    { ext: '.XLSM', icon: fileExcelIcon, color: '#', style: { 'color': '#37b400' } },
    { ext: '.XLSB', icon: fileExcelIcon, color: '#', style: { 'color': '#37b400' } },
    { ext: '.XLT', icon: fileExcelIcon, color: '#', style: { 'color': '#37b400' } },
    { ext: '.PPT', icon: filePptIcon, color: '#', style: { 'color': '#ff9000' } },
    { ext: '.PPTM', icon: filePptIcon, color: '#', style: { 'color': '#ff9000' } },
    { ext: '.PPTX', icon: filePptIcon, color: '#', style: { 'color': '#ff9000' } },
    { ext: '.PPSX', icon: filePresentationIcon, color: '#', style: { 'color': '#ff9000' } },

    //images
    { ext: '.GIF', icon: fileImageIcon, color: '#', style: {} },
    { ext: '.PNG', icon: fileImageIcon, color: '#', style: {} },
    { ext: '.JPG', icon: fileImageIcon, color: '#', style: {} },
    { ext: '.JPEG', icon: fileImageIcon, color: '#', style: {} },
    { ext: '.R3D', icon: fileImageIcon, color: '#', style: {} },

    //zip/rar
    { ext: '.ZIP', icon: fileZipIcon, color: '#', style: {} },
    { ext: '.7Z', icon: fileZipIcon, color: '#', style: {} },
    { ext: '.RAR', icon: fileZipIcon, color: '#', style: {} },
    { ext: '.TAR', icon: fileZipIcon, color: '#', style: {} },
    { ext: '.WIM', icon: fileZipIcon, color: '#', style: {} },


    { ext: '.DWG', icon: Icons.dwgIcon1, color: '#', style: {} },
    { ext: '.DWT', icon: Icons.dwgIcon2, color: '#', style: {} },
    { ext: '.CSV', icon: fileCsvIcon, color: '#', style: { 'color': '#37b400' } },

    { ext: '.TXT', icon: fileTxtIcon, color: '#', style: {} },
    { ext: '.LOG', icon: fileTxtIcon, color: '#', style: {} },

    //video
    { ext: '.MP4', icon: fileVideoIcon, color: '#', style: {} },
    { ext: '.MOV', icon: fileVideoIcon, color: '#', style: {} },
    { ext: '.AVI', icon: fileVideoIcon, color: '#', style: {} },
    { ext: '.WMV', icon: fileVideoIcon, color: '#', style: {} },


    { ext: '.ACCDB', icon: fileMdbIcon, color: '#', style: { 'color': '#790000' } },

    { ext: '.BAT', icon: fileProgrammingIcon, color: '#', style: {} },

    { ext: '.DB', icon: fileConfigIcon, color: '#', style: {} },
    { ext: '.DLL', icon: fileConfigIcon, color: '#', style: {} },
    { ext: '.DRV', icon: fileConfigIcon, color: '#', style: {} },
    { ext: '.INF', icon: fileConfigIcon, color: '#', style: {} },
    { ext: '.INI', icon: fileConfigIcon, color: '#', style: {} },

    { ext: '.EXE', icon: exeIcon, color: '#', style: {} },
    { ext: '.MSG', icon: envelopIcon, color: '#', style: {} },

    { ext: '.HTML', icon: Icons.chromeIcon, color: '#', style: {} },
    { ext: '.HTM', icon: Icons.chromeIcon, color: '#', style: {} },
    { ext: '.SVG', icon: Icons.chromeIcon, color: '#', style: {} },

    { ext: '.URL', icon: hyperlinkOpenIcon, color: '#', style: {} },

    { ext: '.TTF', icon: fontFamilyIcon, color: '#', style: {} },
  ];


  
static getSvgIconByFileName(filename: string) {
  if (!filename) {
    return { icon: fileIcon, style: {} }; // default icon
  }

  const ext = filename.substring(filename.lastIndexOf('.')).toUpperCase();
  const match = iconHelper.svgIcons.find(x => x.ext === ext);

  return match ? match : { icon: fileIcon, style: {} };
}


}